import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FrameEntityModel from '../../../../../../moderation/models/message-entities/frame-entity';
import { ERROR, SUCCESS, LOADING } from '../../../../../../../models/request-status';
import guid from '../../../../../../../../libraries/utils/guid';
import queryString from '../../../../../../../../libraries/utils/query-string';
import {
  INSTAGRAM,
  TWEET
} from '../../../../../../moderation/models/message-entities/frame-entity-types';
import ShowButton from './show-button';

const TIMEOUT_INTERVAL = 15000;

class FrameEntity extends Component {
  constructor(props, context) {
    super(props, context);
    this.timeoutError = null;
    this.id = guid();
    this.frameListener = this.frameListener.bind(this);
    this.show = this.show.bind(this);
    this.state = {
      visible: false,
      status: LOADING,
      width: null,
      height: null
    };
  }
  UNSAFE_componentWillMount() {
    window.addEventListener('message', this.frameListener, false);
  }
  componentWillUnmount() {
    window.removeEventListener('message', this.frameListener);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.status.toLowerCase() === ERROR && prevState.status.toLowerCase() !== ERROR) {
      this.handleError();
    }
  }
  initErrorTimeout() {
    this.timeoutError = setTimeout(this.handleError.bind(this), TIMEOUT_INTERVAL);
  }
  show() {
    this.setState({ visible: true }, () => {
      this.initErrorTimeout();
    });
  }
  isLoaded() {
    return this.state.status.toLowerCase() === SUCCESS;
  }
  frameListener(e) {
    var { componentId, status, height, width } = e.data;
    if (this.id !== componentId) {
      return;
    }
    switch (status.toLowerCase()) {
      case LOADING:
        this.handleLoading();
        break;
      case SUCCESS:
        this.handleSuccess({ height, width });
        break;
      case ERROR:
        this.handleError();
        break;
    }
  }
  clearTimeout() {
    if (this.timeoutError) {
      window.clearTimeout(this.timeoutError);
      this.timeoutError = null;
    }
  }
  handleLoading() {
    this.clearTimeout();
  }
  handleSuccess({ height, width }) {
    this.clearTimeout();
    this.setState({ height, width, status: SUCCESS });
  }
  handleError() {
    this.setState({ status: ERROR });
  }
  render() {
    var { height, width, status, visible } = this.state;
    var entity = this.props.entity;

    var component = null;
    if (visible) {
      let frameStyle = {};
      if (height !== null) {
        frameStyle.height = height;
      }
      if (width !== null) {
        frameStyle.width = width;
      }

      let spinner = null;
      if (status.toLowerCase() !== SUCCESS) {
        spinner = <div className="spinner" />;
      }

      let src = queryString.buildUrl(entity.getFrameSrc(), {
        componentId: this.id
      });

      component = (
        <div className="entity frame-entity">
          <iframe
            ref="iframe"
            className="embed"
            scrolling="no"
            frameBorder="0"
            src={src}
            style={frameStyle}
          />
          {spinner}
        </div>
      );
    } else {
      let iconName = null;
      switch (entity.frameType) {
        case INSTAGRAM:
          iconName = 'attachment-instagram';
          break;
        case TWEET:
          iconName = 'attachment-tweet';
          break;
      }
      component = iconName ? (
        <div className="entity frame-entity">
          <ShowButton iconName={iconName} onClick={this.show} />
        </div>
      ) : null;
    }
    return component;
  }
}

FrameEntity.propTypes = {
  entity: PropTypes.instanceOf(FrameEntityModel).isRequired
};

FrameEntity.displayName = 'FrameEntity';

export default FrameEntity;
